function scroll_search_result() {
  var $search_result = $('.search_result');
  if ( $search_result.length )  {
    $search_result.each(function () {
      var $search_result_offset = $search_result.offset().top;
      $("html, body").animate({ scrollTop: $search_result_offset }, 1000);
    });
  }else {
  }
}

/*-------------------------------------
## On Scroll function call if body
## has has-sticky-menu class
-------------------------------------*/
function stickInParent() {
  $(".header-menu-area").stick_in_parent({
    parent: 'html',
    sticky_class: 'is-menu-stuck',
  });
}


function calculateMeanMenuHeight() {
  var meanMenu = $('.mean-bar');
  var meanHeight = 0;
  if (meanMenu) {
    meanHeight = meanMenu.outerHeight();
  }
  return meanHeight;
}
function calculateElementHeight(selector) {
  var element = $(selector);
  if (element) {
    element_height = element.outerHeight();
  }
  if (element_height) {
    return element_height;
  } else {
    return 0;
  }
}
function assignMarginValueToHtml() {
  var menuBarHeight = calculateElementHeight('.main-header');
  var meanMenuHeight = calculateElementHeight('.mean-bar');
  var maxPaddingTop = Math.max(meanMenuHeight, menuBarHeight);
  var body = $('body');
  body.css({
      paddingTop: maxPaddingTop
  });
}



// hooking all function to ready method
jQuery(document).ready(function($) {
  scroll_search_result();
  assignMarginValueToHtml();
  // stickInParent();
  $(window).on('resize', assignMarginValueToHtml);
});







